import { render } from "./MenuItemSubMenu.vue?vue&type=template&id=85d57db8"
import script from "./MenuItemSubMenu.vue?vue&type=script&lang=js"
export * from "./MenuItemSubMenu.vue?vue&type=script&lang=js"

import "./MenuItemSubMenu.vue?vue&type=style&index=0&id=85d57db8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__